import React, { useState } from "react";
import getSymbolFromCurrency from "currency-symbol-map";
import { toAbsoluteUrl } from "../../_helpers";
import { useHistory } from "react-router-dom";
import {Modal,Button} from "react-bootstrap";
import { MainImagePopup } from "../popup/MainImagePopup";
import VideoIframe from "../popup/VideoIframe";
// import { DETAILPAGE_LOG } from "../../../env_config";
// import axios from "axios";
import { SendInquiry } from "../popup/sendInquiry";
import SafeImage from "../widgets/SafeImage";

export default function ExpandedDetails({row,themeData,ipData,language}) {
    const history = useHistory();
    const [mainimageclick,setMainImageClick] = useState(false)
    const [showVideo, setShowVideo] = React.useState(false);
    const [showAssetImg, setShowAssetImg] = React.useState(false);
    const [showArrowImg, setShowArrowImg] = React.useState(false);
    const [showHeartImg, setShowHeartImg] = React.useState(false);
    function handleClose(event, reason) {
        setShowVideo(false);
        setShowHeartImg(false);
        setShowAssetImg(false);
        setShowArrowImg(false);
    }
    function openVideoModal() {
        setShowVideo(true)
    }
    function openHeartModal() {
        setShowHeartImg(true)
    }

    function openAssetModal() {
        setShowAssetImg(true)
    }

    function openArrowModal() {
        setShowArrowImg(true)
    }
    function handelDetails(){
        history.push({  pathname: '/details', state:{
            StockID:row.STOCK_ID,
            diamond_type:row.COLOR?row.diamond_type:row.diamond_type + "F",
            ipData:ipData
        }})
        window.scrollTo(0, 0)
    }
    function Currency(){
        const cur = row?.CURRENCY || themeData?.api_currency
        return getSymbolFromCurrency(cur) || ""
    }
    function numberWithCommas(x) {
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return (
        <>
            <div className="bg-gray-300 confirmExpand p-5 border">
                <div className="bg-white p-5 border">
                    <div className="row m-0 align-items-center">
                        <div className="col-4 d-flex">
                            <ul className="img_thumb_box mt-4 ml-5 pl-0">
                                <li className="img_thumb">
                                        <div>
                                        <MainImagePopup Image={row.IMAGE} Shape={row.SHAPE} fallback={row.sample} mainimageclick={mainimageclick} setMainImageClick={setMainImageClick}/>
                                        <SafeImage
                                            className="img thumb"
                                            alt={row.SHAPE}
                                            src={row.IMAGE}
                                            fallback={row.sample}
                                            onClick={() => setMainImageClick(true)}
                                        />
                                        </div>
                                </li>
                                {row.VIDEO  ? (
                                    <li className="img_thumb cursor-pointer" onClick={() => openVideoModal()}>
                                        <img  alt="img thumb" src="https://assets.diamondsoncall.com/assets/front/images/pd-2.png" height="40px" width="40px"/>
                                    </li>
                                ):('')}
                                {row.AWS_Heart ? (
                                    <li className="img_thumb cursor-pointer" onClick={() => openHeartModal()}>
                                        <img  alt="img thumb" src="https://assets.diamondsoncall.com/assets/front/images/pd-5.png"/>
                                    </li>
                                    
                                ):('')}
                                {row.AWS_Arrow ? (
                                    <li className="img_thumb cursor-pointer" onClick={() => openArrowModal()}>
                                        <img  alt="img thumb" src="https://assets.diamondsoncall.com/assets/front/images/pd-6.png"/>
                                    </li>
                                ):('')}
                                {row.AWS_Asset ? (
                                    <li className="img_thumb cursor-pointer" onClick={() => openAssetModal()}>
                                        <img  alt="img thumb" src="https://assets.diamondsoncall.com/assets/front/images/pd-3.png"/>
                                    </li>
                                ):('')}
                            </ul>
                            <div className="img_box mt-4">
                                <div>
                                        <MainImagePopup Image={row.IMAGE} Shape={row.SHAPE} fallback={row.sample} mainimageclick={mainimageclick} setMainImageClick={setMainImageClick}/>

                                    <SafeImage
                                        className="img-fluid cursor-pointer"
                                        alt={row.SHAPE}
                                        src={row.IMAGE}
                                        onClick={() => setMainImageClick(true)}
                                        fallback={row.sample}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="row mt-5">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="row m-0">
                                                <div className="col-5 p-0 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_STOCKID} </div>
                                                <div className="col-7"><span>{row.STOCK_ID}</span></div>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-5 p-0 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_SHAPE}</div>
                                                <div className="col-7"><span>{row.SHAPE}</span></div>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-5 p-0 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_LAB} </div>
                                                <div className="col-7"><span>{row.LAB}</span></div>
                                            </div>
                                        </div>
                                        <div className="col-6 px-1">
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_CARAT}</div>
                                                <div className="col-7"><span>{row.CARAT}</span></div>
                                            </div>
                                            
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_COLOR}</div>
                                                <div className="col-7"><span>{!row.FANCY_COLOR ? row.COLOR :<>{row.FANCY_INTENSITY} {row.FANCY_OVERTONE} {row.FANCY_COLOR}</> }</span></div>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_CLARITY}</div>
                                                <div className="col-7"><span>{row.CLARITY}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="w-100 m-0 mb-2" />
                                    <div className="row">
                                        <div className="col-6 px-1">
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_CUT}</div>
                                                <div className="col-7"><span>{row.CUT}</span></div>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_POLISH}</div>
                                                <div className="col-7"><span>{row.POLISH}</span></div>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_SYMMETRY}</div>
                                                <div className="col-7"><span>{row.SYMMETRY}</span></div>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_FLOUR}</div>
                                                <div className="col-7"><span>{row.FLUORESCENCE}</span></div>
                                            </div>
                                            {row.TYPE_CLASSIFICATION && <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_SHORTLISTPAGE_TYPE}</div>
                                                <div className="col-7"><span>{row.TYPE_CLASSIFICATION}</span></div>
                                            </div>}
                                            
                                        </div>
                                        <div className="col-6 px-1">
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_MEASUREMENT}</div>
                                                <div className="col-7"><span className="d-flex">{parseFloat(row.LENGTH).toFixed(2)} x {parseFloat(row.WIDTH).toFixed(2)} x {parseFloat(row.DEPTH).toFixed(2)} </span></div>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_TABLE}</div>
                                                <div className="col-7"><span>{parseFloat(row.TABLE_PER).toFixed(2)}%</span></div>
                                            </div>
                                            <div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_DIAMOND_DETAILS_DEPTH}</div>
                                                <div className="col-7"><span>{parseFloat(row.DEPTH_PER).toFixed(2)}%</span></div>
                                            </div>
                                            {themeData && !themeData.ifm_no_price?<div className="row m-0">
                                                <div className="col-5 font-weight-bold">{language.CCMODE_SHORTLISTPAGE_PRICE}
                                                {/* if ($no_price == 0) {
                                                    $detail .= 'Price';
                                                }
                                                $detail .= ' */}
                                                </div>
                                                <div className="col-7">
                                                    {row.finalDisplayLabelTotalPrice || `${Currency()}${numberWithCommas(row.TOTAL_PRICE)}`}
                                                    {row.taxBreakDown?<div className="font-size-sm text-dark-50 font-weight-normal">{row.taxBreakDown}</div>:""}
                                                {/* if ($no_price == 0) {
                                                    $detail .= '<span>$' . number_format($main_price_total, 2) . '</h4>';
                                                }
                                                $detail .= ' */}
                                                </div>
                                            </div>:""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-2 align-self-end">
                            <SendInquiry diamond_details={row} ipData={ipData} language={language}/>
                            <button className="btn btn-secondary btn-sm my-1" onClick={()=>handelDetails()}>{language.CCMODE_THEME1_GRID_DETAILBTN}</button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                show={showHeartImg}
                onHide={handleClose}
                size="lg"
            >
                <Modal.Body className="text-center">
                    <img src={row.AWS_Heart} alt={row.SHAPE} className="img-fluid" />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showArrowImg}
                onHide={handleClose}
                size="lg"
            >
                <Modal.Body className="text-center">
                    <img src={row.AWS_Arrow} alt={row.SHAPE} className="img-fluid" />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showAssetImg}
                onHide={handleClose}
                size="lg"
            >
                <Modal.Body className="text-center">
                    <img src={row.AWS_Asset} alt={row.SHAPE} className="img-fluid" />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                    >
                    Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <VideoIframe
                showVideo={showVideo}
                handleClose={handleClose}
                src={row.VIDEO }
                // src={row.ext_video || ""}
                data={row}
           />
        </>
    );
}
